<template>
    <div class="container">
        <div class="page">
            <header class="page__heading--first  text-center" id="search">
                <h1 class="page__heading-title h2">Search</h1>
                <p class="page__heading-text">Search for products.</p>
                <div v-if="pagination.total > 0" class="page__heading-prefix pt-2">
                    Found {{ pagination.total }} Products
                </div>
            </header>
            <div class="row justify-content-center">
                <div class="pb-6 col-lg-4">
                    <SearchForm/>
                </div>
                <div class="h-container-a">
                    <transition name="fade" mode="out-in">
                        <AppCardPlaceholder :items="3" v-if="loading" key="no-products"/>
                        <div class="grid grid--product" v-else>
                            <div class="grid__col--sm-4 grid__col--md-3" v-for="product in products">
                                <ProductCard :product="product"/>
                            </div>
                            <div class="grid__col--xs-12 text-center text-muted" v-if="!products.length">No products matching the criteria</div>
                        </div>
                    </transition>
                    <BPagination :value="pagination.page"
                                 :total-rows="pagination.total"
                                 :per-page="pagination.limit"
                                 class="mt-5 pagination__list"
                                 align="center"
                                 @input="pageChanged"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { BPagination } from 'bootstrap-vue';
import SearchForm from '../components/SearchForm';
import ProductCard from '../components/products/ProductCard';
import AppCardPlaceholder from '../components/AppCardPlaceholder';

export default {
  components: {
    SearchForm,
    ProductCard,
    BPagination,
    AppCardPlaceholder,
  },
  computed: {
    ...mapState({
      pagination: state => state.products.pagination,
      loading: state => state.products.loading,
    }),
    ...mapGetters({
      products: 'products/products',
    }),
  },
  methods: {
    pageChanged(page) {
      this.$store.dispatch('products/pageChanged', {
        state: 'search',
        search: this.products.search,
        page,
      });

      const search = document.getElementById('search');
      search.scrollIntoView();
    },
  },
};
</script>
